import { Helmet } from 'react-helmet'
import { getStrapiUrl } from '@src/utils/functions'
import { components } from './Strapi.api.types'

const StrapiSEO = ({ seo }: { seo: components['schemas']['SharedSeoComponent'] | null | undefined }) => {
  if (!seo) return null

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      {seo.metaTitle && <title>{seo.metaTitle}</title>}
      {seo.metaDescription && <meta name="description" content={seo.metaDescription} />}

      {/* Robots */}
      {seo.metaRobots && <meta name="robots" content={seo.metaRobots || 'noindex'} />}

      {/* Viewport */}
      {seo.metaViewport && <meta name="viewport" content={seo.metaViewport} />}

      {/* Keywords */}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}

      {/* Canonical URL */}
      {seo.canonicalURL && <link rel="canonical" href={seo.canonicalURL} />}

      {/* Open Graph Tags */}
      {seo.openGraph && (
        <>
          {seo.openGraph.ogTitle && <meta property="og:title" content={seo.openGraph.ogTitle} />}
          {seo.openGraph.ogDescription && <meta property="og:description" content={seo.openGraph.ogDescription} />}
          {seo.openGraph.ogType && <meta property="og:type" content={seo.openGraph.ogType} />}
          {seo.openGraph.ogUrl && <meta property="og:url" content={seo.openGraph.ogUrl} />}
          {seo.openGraph.ogImage && seo.openGraph.ogImage.url && (
            <meta
              property="og:image"
              content={`${getStrapiUrl()}${
                seo.openGraph.ogImage.url
              }`}
            />
          )}
        </>
      )}

      {/* Structured Data */}
      {seo.structuredData && <script type="application/ld+json">{JSON.stringify(seo.structuredData)}</script>}
    </Helmet>
  )
}

export default StrapiSEO
